import { Dispatch } from 'redux';

import { deleteConfirmation, loggingAllowed, showLogInfo, tooltips } from 'src/constants/profileSettings';
import { actionTypes } from '../../constants/actionTypes';
import GeneratorEntity from '../../models/Generator';
import Profile from '../../models/Profile';
import { loadGenDetails, loadGenerators, loadProfile } from '../../utils/api';




// *************************
//      Generators
// *************************

export function loadGeneratorsStart() {
  return {
    type: actionTypes.LOAD_GENERATORS_START
  }
}

export function deleteGeneratorStart(generator: GeneratorEntity) {
  return {
    payload: generator,
    type: actionTypes.DELETE_GENERATOR_START
  }
}

export function loadGeneratorsSuccess(generators: GeneratorEntity[]) {
  return {
    payload: generators,
    type: actionTypes.LOAD_GENERATORS_SUCCESS
  }
}

export function updateFilter(query: string) {
  return {
    payload: query,
    type: actionTypes.GENERATOR_FILTER_UPDATE
  }
}

function saveEditChangesStart() {
  return {
    type: actionTypes.SAVE_GENERATOR_EDIT_CHANGES_START
  }
}

export function saveEditChanges(dispatch: Dispatch, gen: GeneratorEntity) {
  dispatch(saveEditChangesStart())
  return {
    payload: gen,
    type: actionTypes.SAVE_GENERATOR_EDIT_CHANGES
  }

}

export function loadRemainingGeneratorDetailStart() {
  return {
    type: actionTypes.LOAD_REMAINING_GENERATOR_DETAIL_START
  }
}

export function loadGeneratorDetailSuccess(generator: GeneratorEntity) {
  ("Details for '" + generator.name + "' were successfully loaded."); // tslint:disable-line
  return {
    payload: generator,
    type: actionTypes.LOAD_REMAINING_GENERATOR_DETAIL_SUCCESS
  }
}

export function validationStart() {
  return {
    type: actionTypes.VALIDATION_START
  }
}
export function validationSuccess(result: any, gen: GeneratorEntity ) {
  return {
    payload: {
      data: result,
      generator: gen,
    },
    type: actionTypes.VALIDATION_SUCCESS,

  }
}
// *************************  Node *************************
export function refreshActiveNode() {
    return {
      type: actionTypes.REFRESH_ACTIVE_NODE
    }
  }

export function updateActiveNodeData(dispatch: Dispatch, displayName: string, propertyName: string, nodeType: string) {
  dispatch(sendDataToActiveNode(displayName, propertyName, nodeType))
}

export function sendDataToActiveNode(name: string, property: string, type: string) {
  return {
    payload: {
      displayName: name,
      nodeType: type,
      propertyName: property
    },
    type: actionTypes.UPDATE_ACTIVE_NODE,
  }
}
// Action Functions

export function dispatchFilterEvent(dispatch: Dispatch, query: string ) {
  dispatch(updateFilter(query));
}

// *************************
//      PROFILE
// *************************

export function loadProfileStart() {
  return {
    type: actionTypes.LOAD_PROFILE_START
  }
}
export function loadProfileSuccess(profile: Profile) {
  return {
    payload: profile,
    type: actionTypes.LOAD_PROFILE_SUCCESS
  }
}
function switchGeneratorView(view: string) {
  return {
    payload: view,
    type: actionTypes.SWITCH_GENERATOR_VIEW
  }
}
function switchEditorView(view: string) {
  return {
    payload: view,
    type: actionTypes.SWITCH_EDITOR_VIEW
  }
}
function switchEditorTheme(theme: string) {
  return {
    payload: theme,
    type: actionTypes.SWITCH_EDITOR_THEME
  }
}
function switchApplicationLanguage(language: string) {
  return {
    payload: language,
    type: actionTypes.SWITCH_APP_LANGUAGE
  }
}
function switchTooltips(setting: tooltips) {
  return {
    payload: setting,
    type: actionTypes.SWITCH_TOOLTIPS
  }
}
function toggleLogging(status: loggingAllowed) {
  return {
    payload: status,
    type: actionTypes.TOGGLE_LOGGING
  }
}
function toggleDeleteConfirmation(bool: deleteConfirmation) {
  return {
    payload: bool,
    type: actionTypes.TOGGLE_DELETE_CONFIRMATION
  }
}
function toggleLogInformation(bool: showLogInfo) {
  return {
    payload: bool,
    type: actionTypes.TOGLE_SHOW_LOG_INFO
  }
}

// ACtion functions for Profile Settings
export const toggleDeleteConf = (dispatch: Dispatch, bool: deleteConfirmation) => {
  dispatch(toggleDeleteConfirmation(bool))
}
export const toggleLogInfo = (dispatch: Dispatch, bool: showLogInfo) => {
  dispatch(toggleLogInformation(bool))
}
export const switchGenView = (dispatch: any, view: string) => {
  dispatch(switchGeneratorView(view))
}
export const switchEditView = (dispatch: any, view: string) => {
  dispatch(switchEditorView(view))
}
export const switchEditTheme = (dispatch: any, theme: string) => {
  dispatch(switchEditorTheme(theme))
}
export const switchAppLanguage = (dispatch: Dispatch, language: string) => {
  dispatch(switchApplicationLanguage(language))
}
export const switchTooltipsSettings = (dispatch: any, setting: tooltips) => {
  dispatch(switchTooltips(setting))
}
export const switchLoggingFlag = (dispatch: Dispatch, status: loggingAllowed) => {
  dispatch(toggleLogging(status))
}



// Load Profile and Generators from API
// Load the generators via API
export const loadGens = (dispatch: Dispatch) => {
  dispatch(loadGeneratorsStart())
  loadGenerators().then(genResult => {
    dispatch(loadGeneratorsSuccess(genResult))
  })
}

export const loadRemainingGeneratorDetails = (dispatch: Dispatch, id: string) => {
  dispatch(loadRemainingGeneratorDetailStart())
  loadGenDetails(id).then((result) => {
    if (result) {
      dispatch(loadGeneratorDetailSuccess(result))
    }
  })
}
// Load the profile of the user
export const loadProfileSettings = (dispatch: any) => {
  dispatch(loadProfileStart())
  loadProfile().then(result => {
    dispatch(loadProfileSuccess(result))
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/index.tsx